import type { FC } from "react";
import { Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { DynamicShared } from "../dynamicShared";
import { DocumentLink, type DownloadFileMutation } from "../dynamicShared/DocumentLink";
import type { SavedDocumentSource } from "../dynamicForm/types";
import { toFileReference } from "../dynamicForm/types";
import { FileTextIcon } from "../shared/icons";
import { AgreementDate } from "./AgreementDate";

type AgreementLinkProps = {
  agreement: { title: string; validUntil?: string } & SavedDocumentSource;
  downloadFileMutation: DownloadFileMutation;
  sx?: SxProps<Theme>;
};

export const AgreementLink: FC<AgreementLinkProps> = ({ agreement, downloadFileMutation, sx }) => {
  const content = (
    <Typography
      component="span"
      sx={[{ fontSize: theme => theme.typography.pxToRem(14) }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {agreement.kind === "file" ? (
        <DocumentLink
          reference={toFileReference(agreement, agreement.title)}
          downloadFileMutation={downloadFileMutation}
        />
      ) : (
        agreement.title
      )}
      <AgreementDate agreement={agreement} />
    </Typography>
  );

  if (agreement.kind === "file") return content;

  return (
    <DynamicShared.ExternalLink Icon={FileTextIcon} href={agreement.url} title={agreement.url}>
      {content}
    </DynamicShared.ExternalLink>
  );
};
